import { useEffect } from 'react';

const useScript = (url, async) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.async = async ? true: false;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, [url]);
};

export default useScript;
